// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","wrapper":"Header_wrapper__SXTn0","logo":"Header_logo__shVBB"};